exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".plagin-wrapper[data-v-32084f40]{-webkit-box-sizing:border-box;box-sizing:border-box;width:100%;position:relative;margin-top:-.5px}.plagin-wrapper img[data-v-32084f40]{width:100%;height:auto}", ""]);

// exports
